export const common = {
  // Navigation
  nav: {
    home: 'Home',
    freshFish: 'Fresh Fish',
    grilledFish: 'Grilled Fish',
    about: 'About',
    contact: 'Contact',
    supplier: 'Supplier',
    cart: 'Cart'
  },
  // Hero
  hero: {
    title: 'Daily catch products and quality grills',
    description: 'Discover our selection of ultra-fresh fish caught daily and our delicious grilled fish prepared according to Cameroonian tradition.',
    delivery: 'Fast delivery throughout Douala.',
    principle: 'Principle: To guarantee availability, order the day before, from 3kg of each, and let us advise you.',
    orderFresh: 'Order Fresh Fish',
    viewGrilled: 'View Grilled Fish'
  },
  // Fresh Fish Section
  freshFish: {
    title: 'Fresh Fish of the Day',
    description: 'Daily selection of ultra-fresh fish. Add your products to the cart and finalize your order via WhatsApp for fast delivery in Douala.',
    tagline: 'Eat Fresh offers seafood products, every day and always fresh....',
    fresh: 'Fresh',
    addToCart: 'Add to cart',
    perKg: 'FCFA/kg',
    perPiece: 'FCFA/piece',
    onRequest: 'On request'
  },
  // Grilled Fish Section
  grilledFish: {
    title: 'Traditional Grilled Fish',
    description: 'Enjoy our grilled fish prepared according to Cameroonian tradition. Perfect for family meals or with friends.',
    deliveryInfo: 'Traditional grilled fish, delivered from 6pm to your home.',
    salesPoints: 'Sales points: Makepe BM, Makepe behind Afriland Poulenc roundabout',
    deliveryZones: 'Delivery zones: Douala 5th',
    accompaniments: 'Available accompaniments:',
    accompanimentsList: 'Plantain fries • Miondo • Bobolo',
    eventService: 'Event Service',
    eventDescription: 'Our team is available for your events: weddings, birthdays, corporate receptions and all your special celebrations.',
    grilled: 'Grilled',
    addToCart: 'Add to cart'
  },
  // About Section
  about: {
    title: 'Why Choose Eat Fresh by 2π?',
    description: 'Since our creation, we are committed to providing the freshest fish in Douala. Our team selects the best products daily to guarantee your satisfaction.',
    freshness: 'Guaranteed Freshness',
    freshnessDesc: 'Fish caught daily and delivered the same day',
    quality: 'Superior Quality',
    qualityDesc: 'Rigorous selection of the best seafood products',
    delivery: 'Fast Delivery',
    deliveryDesc: 'Any order placed the day before delivered at any time of the day.',
    traditional: 'Traditional Preparation',
    traditionalDesc: 'Grilled fish according to authentic Cameroonian recipes',
    salesConditions: 'Sales Conditions',
    condition1: 'The order is only guaranteed by stock availability',
    condition2: 'Refund guaranteed in case of unavailability if the order has been validated and money collected'
  },
  // Contact Section
  contact: {
    title: 'Contact Us',
    description: 'We are here to answer any questions or special orders',
    phone: 'Phone',
    whatsapp: 'WhatsApp',
    address: 'Address',
    addressValue: 'Douala, Cameroon',
    hours: 'Opening Hours',
    everyday: 'Every day',
    freshFishHours: 'Fresh fish: from 7:30 AM',
    grilledDeliveryHours: 'Grilled delivery: from 6:00 PM'
  },
  // Footer
  footer: {
    description: 'Your trusted source for quality fresh and grilled fish in Douala.',
    navigation: 'Navigation',
    contact: 'Contact',
    hours: 'Hours',
    everyday: 'Every day',
    freshFishHours: 'Fresh fish: from 7:30 AM',
    grilledDeliveryHours: 'Grilled delivery: from 6 PM',
    rights: '© 2024 Eat Fresh by 2π. All rights reserved.',
    poweredBy: 'WOW (WhatsApp Order Website) powered by Wazi Consulting'
  },
  // Cart
  cart: {
    title: 'My Cart',
    empty: 'Your cart is empty',
    unitPrice: 'Unit price',
    total: 'Total',
    clearCart: 'Clear cart',
    finalizeWhatsApp: 'Finalize on WhatsApp',
    kg: 'kg',
    pieces: 'piece',
    comment: 'Comment (optional)',
    commentPlaceholder: 'Add a comment for your order...',
    characters: 'characters',
    priceNote: 'Prices may vary depending on availability and size. The final price will be confirmed when preparing your order.',
    recipientInfo: 'Recipient name and number',
    recipientPlaceholder: 'Ex: John Doe - 690123456',
    paymentNumbers: 'Payment numbers',
    orderSent: 'Order sent!',
    orderSentDesc: 'Your order has been sent via WhatsApp. We will contact you soon to confirm.',
    understood: 'Got it!'
  },
  // Supplier
  supplier: {
    title: 'Supplier Area',
    description: 'Enter your information and register your fresh fish stock of the day',
    supplierInfo: 'Supplier information',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone number',
    addFish: 'Add a fish',
    fishType: 'Fish type',
    selectFish: 'Select a fish',
    quantity: 'Quantity (kg)',
    price: 'Price (FCFA/kg)',
    addToStock: 'Add to stock',
    dailyStock: 'Daily stock',
    clearAll: 'Clear all',
    noFish: 'No fish added',
    totalAvailable: 'Total available',
    sendWhatsApp: 'Send stock via WhatsApp',
    fillAllFields: 'Please fill in all fields',
    addAtLeastOne: 'Please add at least one fish to stock',
    fillPersonalInfo: 'Please fill in your personal information',
    confirmClear: 'Do you really want to clear all stock?'
  },
  // WhatsApp Messages
  whatsapp: {
    freshOrder: 'Fresh Fish Order',
    grilledOrder: 'Grilled Fish Order',
    quantity: 'Quantity',
    unitPrice: 'Unit price',
    total: 'Total',
    toConfirm: 'To confirm',
    onRequest: 'On request',
    comment: 'Comment',
    priceNote: 'Note: Prices are indicative and may vary.',
    confirmOrder: 'Please confirm my order and indicate delivery terms.',
    stockTitle: 'Fresh Fish Stock of the Day',
    date: 'Date',
    supplier: 'Supplier',
    phone: 'Phone',
    totalAvailable: 'Total',
    kgAvailable: 'kg available',
    sentBySupplier: 'Stock sent by supplier'
  },
  // Products
  products: {
    bar: 'Fresh Sea Bass',
    barDesc: 'Fresh sea bass, premium fish for special occasions',
    bossus: 'Fresh Bossus',
    bossusDesc: 'Fresh bossus, tender and delicate flesh, quality local fish',
    brochet: 'Pike',
    brochetDesc: 'Fresh pike of the day, quality freshwater fish, firm and tasty flesh, ideal for your recipes',
    capitaine: 'Captain Fish',
    capitaineDesc: 'Fresh captain fish of the day, quality local fish, firm and tasty flesh',
    carangue: 'Jack Fish',
    carangueDesc: 'Fresh jack fish of the day, tasty sea fish, sold per kg of superior quality',
    carpe: 'Fresh Carp',
    carpeDesc: 'Fresh carp of the day, perfect for your traditional recipes',
    crabes: 'Crabs',
    crabesDesc: 'Fresh crabs of superior quality, tasty and delicate flesh, perfect for your seafood dishes',
    crevettes: 'Pink Shrimps',
    crevettesDesc: 'Fresh pink shrimps of superior quality, tender and tasty flesh',
    dorade: 'Grey Sea Bream',
    doradeDesc: 'Fresh royal sea bream, refined flavor and perfect texture',
    escargot: 'Snails',
    escargotDesc: 'Fresh snails of superior quality, local delicacy appreciated for its unique flavor',
    escargotCleaned: 'Cleaned Snails',
    escargotCleanedDesc: 'Cleaned snails ready to cook, premium quality for your refined recipes',
    gambas: 'Prawns',
    gambasDesc: 'Fresh prawns of superior quality, ideal for your seafood dishes',
    machoiron: 'Fresh Machoiron',
    machoironDesc: 'Premium quality machoiron, ideal for grilling and sauces',
    mulet: 'Mullet',
    muletDesc: 'Fresh mullet of the day, tasty and versatile fish, perfect for all your culinary preparations',
    sole: 'Fresh Sole',
    soleDesc: 'Fresh sole, delicate flatfish, perfect for children',
    tilapia: 'Tilapia',
    tilapiaDesc: 'Fresh tilapia of the day, tasty and versatile freshwater fish, perfect for all your preparations',
    barGrilled: 'Grilled Sea Bass',
    barGrilledDesc: 'Grilled sea bass, premium preparation for connoisseurs',
    capitaineGrilled: 'Grilled Captain Fish',
    capitaineGrilledDesc: 'Captain fish grilled to perfection with our special spices',
    carpeGrilled: 'Grilled Carp',
    carpeGrilledDesc: 'Grilled carp marinated with local herbs',
    machoironGrilled: 'Grilled Machoiron',
    machoironGrilledDesc: 'Grilled machoiron with spicy sauce, a Cameroonian delight',
    maquereauGrilled: 'Grilled Mackerel',
    maquereauGrilledDesc: 'Grilled mackerel with traditional spices, authentic flavor',
    silureGrilled: 'Grilled Catfish',
    silureGrilledDesc: 'Tender and tasty grilled catfish, carefully prepared',
    soleGrilled: 'Grilled Sole',
    soleGrilledDesc: 'Delicately prepared grilled sole, tender and tasty flesh',
    brochette: 'Grilled Pork Skewer',
    brochetteDesc: 'Pork skewer grilled to perfection, tender and tasty meat'
  }
};
